import React from 'react';

interface EditIconProps {
  className?: string;
}

function EditIcon({ className }: EditIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
      className={className}
    >
      <g id="Icon/Edit">
        <path
          id="Icon"
          fill="currentColor"
          fillRule="evenodd"
          d="M20 3.212c-.297 0-.583.118-.793.328l-9.304 9.305-.529 2.114 2.115-.529 9.304-9.304A1.121 1.121 0 0 0 20 3.212m-2.207-1.086a3.121 3.121 0 0 1 4.414 4.414l-9.5 9.5a1 1 0 0 1-.465.263l-4 1a1 1 0 0 1-1.212-1.212l1-4a1 1 0 0 1 .263-.465zM1.879 4.212A3 3 0 0 1 4 3.333h7a1 1 0 1 1 0 2H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7a1 1 0 1 1 2 0v7a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-14a3 3 0 0 1 .879-2.121"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
}

export default EditIcon;
